import { localStorageRemoveItem } from "../App";

export const queryError = (e, showToast, navigate) => {
  let resMessage = 'An unexpected error occurred';

  if (e.message === 'Network Error') {
    resMessage = 'Unable to connect. Please check your internet connection and try again.';
  } 
  else if (e.message?.includes('TIMED_OUT') || e.message?.includes('ERR_TIMED_OUT')) {
    resMessage = 'Connection timed out. Please check your internet connection and try again.';
  } 
  else if (e.message?.includes('CONNECTION_CLOSED') || e.message?.includes('ERR_CONNECTION_CLOSED')) {
    resMessage = 'Connection was closed unexpectedly.';
  } 
  else if (e.response) {
    const { status, data } = e.response;
    if ([400, 401, 404, 405, 409].includes(status)) {
      resMessage = data?.message || 'An unexpected error occurred';
    } else if (status === 500) {
      resMessage = 'We are experiencing technical issues. Please try again later.';
    }

    if (status === 401) {
      localStorageRemoveItem("userData");
      localStorageRemoveItem("userToken");
      localStorageRemoveItem("totalWishlistItems");
      navigate("/login");

      showToast({ toastText: 'Session timeout. Please log in again.', isSuccess: false });
      return;
    }
  }

  if (typeof showToast === "function") {
    showToast({ toastText: resMessage, isSuccess: false });
  } else {
    console.error("showToast is not a function", resMessage);
  }
};
